import { render, staticRenderFns } from "./letters.vue?vue&type=template&id=772f3cc8&"
import script from "./letters.vue?vue&type=script&lang=js&"
export * from "./letters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports